
const CalculUtils = {

  achats: (prixAchatHT, quantite) => parseFloat(prixAchatHT) * parseFloat(quantite),
  reviens: (prixAchatHT, freinte, transformation, quantite) => (parseFloat(quantite) / (parseFloat(quantite) - (parseFloat(quantite) * parseFloat(freinte) / 100)) * parseFloat(prixAchatHT)) * parseFloat(transformation) || 0,
  vente: (prixVenteTTC, quantite, casse, freinte, transformation) => ((parseFloat(quantite) - (parseFloat(quantite) * parseFloat(freinte) / 100)) - parseFloat(casse) - ((parseFloat(quantite) * parseFloat(transformation)) - parseFloat(quantite))) * parseFloat(prixVenteTTC),
  venteRemise: (prixVenteTTC, quantite, remise) => parseFloat(quantite) * (parseFloat(prixVenteTTC) - (parseFloat(prixVenteTTC) * (parseFloat(remise) / 100))),
  margeValeur: (achatsHT, venteTTC) => {
    if (parseFloat(achatsHT) > 0 && parseFloat(venteTTC) > 0) { return CalculUtils.round(parseFloat(venteTTC) / 1.055 - parseFloat(achatsHT)) } return 0
  },
  venteHT: (prixVenteTTC, quantite, casse, transformation = 1, freinte = 0) => {
    const qteTransformation = CalculUtils.round2(parseFloat(quantite) / parseFloat(transformation) - parseFloat(casse))
    return (qteTransformation - (qteTransformation * (parseFloat(freinte) / 100))) * (parseFloat(prixVenteTTC) / 1.055)
  },
  margeValeurHT: (achatsHT, venteHT) => {
    if (parseFloat(achatsHT) > 0 && parseFloat(venteHT) > 0) { return CalculUtils.round(parseFloat(venteHT) - parseFloat(achatsHT)) } return 0
  },
  margeCasseValeur: achatsHT => {
    if (parseFloat(achatsHT) > 0) { return CalculUtils.round(-parseFloat(achatsHT)) } return 0
  },
  margePourcentage: (achatsHT, venteTTC) => {
    const venteHT = (parseFloat(venteTTC) / 1.055)
    return CalculUtils.margeValeur(achatsHT, venteTTC) * 100 / venteHT
  },
  margePourcentageHT: (achatsHT, venteHT) => {
    return CalculUtils.margeValeurHT(achatsHT, venteHT) * 100 / venteHT
  },
  sumList: (list, properties) => CalculUtils.round(list.reduce((total, now) => total + parseFloat(now[properties]), 0)),
  sumList2: (list, properties) => CalculUtils.round(list.reduce((total, now) => total + parseFloat(now[properties]), 2)),
  toPourcentage: (base, nb) => (parseFloat(nb) * 100) / parseFloat(base),
  progressionPourcent: (vd, va) => CalculUtils.round2(((va - vd) / vd) * 100),
  // reste - prendre en compte la freinte
  toEuros: value => {
    if (!value || isNaN(value) || value === Infinity || value === -Infinity) {
      return '0.00 €'
    } if (value.length > 6 && value.includes('.')) {
      return `${Math.round(parseFloat(value))} €`
    }
    return `${CalculUtils.round2(parseFloat(value)).toFixed(2)} €`
  },
  // Fonction spéciale pour le simulateur avec formatage français (espaces dans les milliers)
  toEurosFormatted: value => {
    if (!value || isNaN(value) || value === Infinity || value === -Infinity) {
      return '0,00 €'
    }
    
    const numValue = parseFloat(value)
    
    if (value.length > 6 && value.includes('.')) {
      return `${Math.round(numValue).toLocaleString('fr-FR')} €`
    }
    
    return `${CalculUtils.round2(numValue).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} €`
  },
  toNumber: (value, fixed) => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
      return '-'
    }
    return CalculUtils.round2(value).toFixed(fixed)
  },
  round2: nb => Math.round(nb * 100) / 100,

  round: (nb, precision = 2) => {
    const roundingMultiplier = Math.pow(10, precision)
    const newValueAsNum = isNaN(nb) ? 0 : parseFloat(+nb)
    return (Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier).toFixed(precision)
  },

  display: (element, zero = true) => {
    if (element === 0 && zero) {
      return 0
    } if (element === Infinity || element === -Infinity) {
      return '-'
    }
    return element || '-'
  }
}

export default CalculUtils
